import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { AnalyticsMode } from '@core/analytics-types';

export type SaveProps = {
  visibleSections: string[];
  editableSections: string[];
  candidates: number;
};

@Injectable()
export class ShareCandidatesWithContextAnalytics extends AnalyticsBase {
  public readonly namespace = 'ShareCandidates';
  public readonly requireViewContext = true;

  public trackSavePublicLink(props: SaveProps) {
    this.track('SavePublicLink', props, {
      integrations: { All: false, Mixpanel: true, Intercom: true },
    });
  }

  public trackCopyPublicLink() {
    this.track('CopyPublicLink', undefined, {
      integrations: { All: false, Mixpanel: true, Intercom: true },
    });
  }

  public trackClickShare(mode: AnalyticsMode): void {
    this.track('ClickShare', { mode });
  }
}
